import FormattedMessage from 'I18n/components/FormattedMessage';
import { Paginator as FoundationsPaginator } from 'foundations-components/transitional/components/Paginator';
import { useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import unescapedText from 'I18n/utils/unescapedText';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Button } from 'foundations-components/transitional/components/Button';
import { List, ListItem } from 'foundations-components/transitional/components/List';

// The maximum number of records crmsearch can page through
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RESULTSET_LIMIT = 10000;
const Paginator = ({
  pageIndex,
  pageSize,
  pageSizes,
  totalRowCount,
  onPageIndexChange,
  onPageSizeChange
}) => {
  const pageCount = Math.ceil(totalRowCount / pageSize);

  // The paginator treats the page numbers as 1-indexed, while the table api treats
  // them as 0-indexed. This is why we subtract 1 in this callback and add 1 in the prop.
  const handlePageChange = useCallback(({
    target: {
      value
    }
  }) => onPageIndexChange({
    nextPageIndex: value - 1
  }), [onPageIndexChange]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    children: [/*#__PURE__*/_jsx(FoundationsPaginator, {
      "data-test-id": "table-paginator",
      page: pageIndex + 1,
      pageCount: pageCount,
      onPageChange: handlePageChange,
      enabledPageLimit: RESULTSET_LIMIT / pageSize,
      disabledPageTooltipTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "datatable.pagination.tooManyRecords"
      })
    }), /*#__PURE__*/_jsx(Dropdown, {
      "data-test-id": "table-page-size-selector",
      "data-test-value": pageSize,
      buttonUse: "transparent",
      buttonText: unescapedText('datatable.pagination.pageCountButton', {
        count: pageSize
      }),
      children: /*#__PURE__*/_jsx(List, {
        children: pageSizes.map(size => /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": `page-size-${size}`,
            use: "link",
            onClick: () => onPageSizeChange({
              nextPageSize: size
            }),
            children: unescapedText('datatable.pagination.pageCountButton', {
              count: size
            })
          })
        }, size))
      })
    })]
  });
};
export default Paginator;